module.exports = __webpack_public_path__ + "e843c51c0eec3801b70cae5c45ad343f.svg";